import { render, staticRenderFns } from "./AppEditableComment.vue?vue&type=template&id=d744f516&"
import script from "./AppEditableComment.vue?vue&type=script&lang=js&"
export * from "./AppEditableComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports